import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Announcement.css'; // Optional CSS file for better styling
import * as Constants from '../../Constant/constant';
import Swal from 'sweetalert2';


const AnnouncementList = () => {
  const [announcements, setAnnouncements] = useState([]);
    const [libraries, setLibraries] = useState([]);
  const navigate = useNavigate();
  const [editingAnnouncementId, setEditingAnnouncementId] = useState(null);
  const [editingTitle, setEditingTitle] = useState('');
  const [editingDescription, setEditingDescription] = useState('');
    const [previewImage, setPreviewImage] = useState(null);
  const [editingDate, setEditingDate] = useState('');
    const [popupImage, setPopupImage] = useState(null);

  useEffect(() => {
    fetchAnnouncements();
    fetchLibraries();
}, []);

const fetchLibraries = async () => {
  try {
    const res = await axios.get(Constants.API_PATH + '/add_new_library_data');
    setLibraries(res.data);
  } catch (error) {
    console.error('Error fetching libraries:', error);
  }
};

fetchLibraries();



const getLibraryName = (id) => {
  const lib = libraries.find(lib => lib.id === id || lib.library_id === id);
  return lib ? (lib.name || lib.library_name) : 'Unknown Library';

};


const fetchAnnouncements = async () => {
    try {
        const res = await axios.get(Constants.API_PATH + '/announcements');
        setAnnouncements(res.data);
    } catch (error) {
        console.error('Error fetching announcements:', error);
    }
};

// Function to open the edit modal
const openEditModal = (announcement) => {
    setEditingAnnouncementId(announcement.id);
    setEditingTitle(announcement.title);
    setEditingDescription(announcement.description);
    setEditingDate(announcement.announcement_date);

    setPreviewImage(announcement.desc_img);
};
    
const sendEmailsToUsers = async (title, description, announcement_date) => {
  try {
      const response = await axios.post(Constants.API_PATH + '/send-announcement-mail', {
          title,
          description,
          announcement_date
      });

      if (!response.ok) {
          throw new Error(`Failed to send emails: ${response.status}`);
      }

      console.log('Emails sent successfully!');
  } catch (error) {
      console.error('Error sending emails:', error);
  }
};

    // Handle updating announcement data
    const handleUpdateAnnouncement = async (e) => {
      e.preventDefault(); // Prevent the default form submission

      try {
          const response = await axios.put(`${Constants.API_PATH}/announcements/${editingAnnouncementId}`, {
              title: editingTitle,
              description: editingDescription,
              announcement_date: editingDate,
              desc_img: previewImage
          });

          if (!response.ok) {
              throw new Error('Failed to update announcement');
          }

          // Send emails after updating
          await sendEmailsToUsers(editingTitle, editingDescription, editingDate, previewImage);

          // Reset editing states
          setEditingAnnouncementId(null);
          setEditingTitle('');
          setEditingDescription('');
          setEditingDate('');
          fetchAnnouncements();
            setPreviewImage(null);
      } catch (error) {
          console.error('Error updating announcement:', error);
      }
  };

    // Handle deleting an announcement
    const handleDeleteAnnouncement = async (id) => {
        if (window.confirm('Are you sure you want to delete this announcement?')) {
            try {
                const response = await axios.delete(`${Constants.API_PATH}/announcements/${id}`);

                if (!response.ok) {
                    throw new Error('Failed to delete announcement');
                }
                fetchAnnouncements();
            } catch (error) {
                console.error('Error deleting announcement:', error);
            }
        }
    };


    const showImagePopup = (imageUrl) => {
  Swal.fire({
    title: 'Announcement Image',
    imageUrl: imageUrl,
    imageAlt: 'Announcement',
    showCloseButton: true,
    imageHeight: 400,
    imageWidth: '600',
    confirmButtonText: 'Close',
    customClass: {
      popup: 'swal-image-popup'
    }
  });
};



    

    return (
        <div className="book-list-container containernew">
            <div className="announcement-header">
                <h2>All Announcements</h2>
                <button className="add-btn" onClick={() => navigate('/add-announcement')}>
                    ➕ Add New
                </button>
            </div>

            {announcements.length > 0 ? (
                <table className="announcement-table custom-table">
                    <thead>
                        <tr>
                            <th>Sr No</th>
                            <th>Library Name</th>
                            <th>Title</th>
                            
                            <th>Description</th>
                            <th>Date</th>
                            <th>Attachment</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {announcements.map((a, index) => (
                            <tr key={a.id}>
                                <td>{index + 1}</td>
                                <td>{getLibraryName(a.library_id)}</td>
                                <td>{a.title}</td>
                                
                                <td>{a.description}</td>
                                <td>{a.announcement_date ? new Date(a.announcement_date).toLocaleDateString() : ''}</td>
                                {/* <td>  {a.desc_img ? (
  <img
  src={`${Constants.IMAGE_BASE_URL}/uploads/announcements/${a.desc_img}`}
  alt="Announcement"
  style={{ maxWidth: '200px', borderRadius: '5px', cursor: 'pointer' }}
  onClick={() => showImagePopup(`${Constants.IMAGE_BASE_URL}/uploads/announcements/${a.desc_img}`)}
/>

                                    
  ) : (
    <span>No Image</span>
  )}</td> */}

  <td>
  {a.desc_img ? (
    (() => {
      const fileUrl = `${Constants.IMAGE_BASE_URL}/uploads/announcements/${a.desc_img}`;
      const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(a.desc_img);
      const isPDF = /\.pdf$/i.test(a.desc_img);

      if (isImage) {
        return (
          <img
            src={fileUrl}
            alt="Announcement"
            style={{ maxWidth: '200px', borderRadius: '5px', cursor: 'pointer' }}
            onClick={() => showImagePopup(fileUrl)}
          />
        );
      } else if (isPDF) {
        return (
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#007bff', textDecoration: 'underline' }}
          >
            View PDF
          </a>
        );
      } else {
        return <span>Unsupported File</span>;
      }
    })()
  ) : (
    <span>No File</span>
  )}
</td>

                                <td>
                                    <button className="edit-btn" onClick={() => openEditModal(a)}>Edit</button>
                                    <button className="delete-btn" onClick={() => handleDeleteAnnouncement(a.id)}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>No announcements available.</p>
            )}

            {popupImage && (
  <div className="image-popup-overlay" onClick={() => setPopupImage(null)}>
    <div className="image-popup-content" onClick={e => e.stopPropagation()}>
      <span className="close-popup" onClick={() => setPopupImage(null)}>&times;</span>
      <img src={popupImage} alt="Popup" className="popup-image" />
    </div>
  </div>
)}


            {/* Edit Announcement Modal */}
            {editingAnnouncementId && (
                <div className="modal">
                    <div className="modal-content">
                        <span className="close" onClick={() => setEditingAnnouncementId(null)}>&times;</span>
                        <h2>Edit Announcement</h2>
                        <form onSubmit={handleUpdateAnnouncement}>
                            <label>Title:</label>
                            <input type="text" value={editingTitle} onChange={(e) => setEditingTitle(e.target.value)} />
                            <label>Description:</label>
                            <textarea value={editingDescription} onChange={(e) => setEditingDescription(e.target.value)}></textarea>
                            <label>Date:</label>
                            <input type="date" value={editingDate} onChange={(e) => setEditingDate(e.target.value)} />
                            <label>Attachment:</label>
                            <input
                                type="file"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        setPreviewImage(file);
                                    } else {
                                        setPreviewImage(null);
                                    }
                                }}
                                accept="image/*"
                                placeholder="Upload Image"
                                style={{
                                    padding: '10px',
                                    border: '1px solid #ccc',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                }}
                            />
                            <button type="submit">Update</button>
                        </form>
                    </div>
                </div>
            )}
        
        </div>
    );
};

export default AnnouncementList;
